<template>
  <div class="selector-overlay" v-on:click="$emit('close')">
  </div>
  <div class="selector-modal">
    <div class="modal-head">
      <div class="title">
        이미지를 선택해주세요.
      </div>
      <button class="btn-close" v-on:click="$emit('close')">
        <svgCrossClose/>
      </button>
    </div>
    <div class="images-outer">
      <button class="btn-nav" v-on:click="goPrev">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.2929 21.7071C15.6834 22.0976 16.3166 22.0976 16.7071 21.7071C17.0976 21.3166 17.0976 20.6834 16.7071 20.2929L15.2929 21.7071ZM7 12L6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L7 12ZM16.7071 3.70711C17.0976 3.31658 17.0976 2.68342 16.7071 2.29289C16.3166 1.90237 15.6834 1.90237 15.2929 2.29289L16.7071 3.70711ZM16.7071 20.2929L7.70711 11.2929L6.29289 12.7071L15.2929 21.7071L16.7071 20.2929ZM7.70711 12.7071L16.7071 3.70711L15.2929 2.29289L6.29289 11.2929L7.70711 12.7071Z" fill="#5A5A5A"/>
        </svg>
      </button>
      <div class="images" ref="track">
        <SampleImageItem 
          v-for="image, i in images"
          v-on:click="setImage($IMG(`assets/samples/${image}`))"
          :image="$IMG(`assets/samples/${image}`)"
          :key="i"
        />
      </div>
      <button class="btn-nav" v-on:click="goNext">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.70711 2.29289C8.31658 1.90237 7.68342 1.90237 7.29289 2.29289C6.90237 2.68342 6.90237 3.31658 7.29289 3.70711L8.70711 2.29289ZM17 12L17.7071 12.7071C18.0976 12.3166 18.0976 11.6834 17.7071 11.2929L17 12ZM7.29289 20.2929C6.90237 20.6834 6.90237 21.3166 7.29289 21.7071C7.68342 22.0976 8.31658 22.0976 8.70711 21.7071L7.29289 20.2929ZM7.29289 3.70711L16.2929 12.7071L17.7071 11.2929L8.70711 2.29289L7.29289 3.70711ZM16.2929 11.2929L7.29289 20.2929L8.70711 21.7071L17.7071 12.7071L16.2929 11.2929Z" fill="#5A5A5A"/>
        </svg>
      </button>
    </div>

    <div class="images-pagination">
      <div class="item"
        v-for="i in Math.ceil(images.length/3)"
        v-on:click="goPage(i)"
        :key="i"
        :class="{
          active: currentPage === i
        }"
      >
      </div>
    </div>
  </div>
</template>

<script>

// import svgImage from '@/svg/svgImage'
import svgCrossClose from '@/svg/svgCrossClose'
import SampleImageItem from '@/components/demos/SampleImageItem'

export default {
  props: {
    images: {
      type: Array,
      default: ()=> {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9]
      }
    }
  },
  data() {
    return {
      currentPage: 1,
      mode: 'desktop'
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, false)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize, false)
  },
  emits: [
    'set', 'close'
  ],
  methods: {
    setImage(url) {
      this.$emit('set', url)
    },
    onResize() {
      if (this.mode !== 'tablet' && window.innerWidth <= 940) {
        this.mode = 'tablet'
        this.goPage(this.currentPage)
      } else if (this.mode !== 'mobile' && window.innerWidth <= 730) {
        this.mode = 'mobile'
      } else if (this.mode !== 'desktop' && window.innerWidth > 940) {
        this.mode = 'desktop'
        this.goPage(this.currentPage)
      }
    },
    goPrev() {
      this.goPage(this.currentPage - 1)
    },
    goNext() {
      this.goPage(this.currentPage + 1)
    },
    goPage(i) {
      let amount = this.mode === 'desktop' ? 630 : 570
      let page = Math.min(Math.max(i, 1), Math.ceil(this.images.length/3))
      this.$refs.track.scrollLeft = (page - 1) * amount
      this.currentPage = page
    }
  },
  components: {
    svgCrossClose,
    SampleImageItem,
    // svgImage
  }
}

</script>

<style lang="scss" scoped>
.selector-overlay {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(#000, 0.25);
  z-index: 100;
}

.selector-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: white;
  transform: translate3d(-50%, -50%, 0);
  z-index: 110;
  padding: 30px 0;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(32, 32, 32, 0.15);

  @media screen and (max-width: 730px) {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    transform: none;
  }
}

.modal-head {
}

.modal-head .title {
  font-size: 20px;
  font-weight: 700;
  margin: 0 auto;
  text-align: center;
}

button.btn-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: #fff;
  border-radius: 5px;
  border: 0;
  width: 48px;
  height: 48px;
  padding: 0;
  &:hover {
    background-color: var(--gray-200);
  }
  &:active {
    background-color: var(--gray-300);
  }
  svg {
    width: 24px;
    height: 24px;
    margin: 0 auto;
  }
}

.images-outer {
  margin: 30px 0;
  display: flex;
  align-items: center;
}
.images {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  width: 620px;
  @media screen and (max-width: 940px) {
    width: 560px;
  }
  @media screen and (max-width: 730px) {
    // width: 100%;
    width: auto;
    display: grid;
    grid-gap: 8px;
    grid-template-columns: 160px 160px 160px;
    margin: 0 auto;
  }
  @media screen and (max-width: 640px) {
    grid-template-columns: 160px 160px;
    max-height: 600px;
    overflow: auto;
  }
}


.images-pagination {
  display: flex;
  justify-content: center;
  @media screen and (max-width: 730px) {
    display: none;
  }
}

.images-pagination .item {
  width: 10px;
  height: 10px;
  background-color: var(--gray-300);
  border-radius: 50%;
  margin: 0 5px;
  &.active {
    background-color: var(--primary-500);
  }
}

button.btn-nav {
  cursor: pointer;
  background-color: #fff;
  border-radius: 5px;
  border: 0;
  width: 48px;
  height: 48px;
  margin: 0 10px;
  &:hover {
    background-color: var(--gray-200);
  }
  &:active {
    background-color: var(--gray-300);
  }
  @media screen and (max-width: 730px) {
    display: none;
  }
}

</style>